<template>

    <div class="field has-addons">
        <div class="control has-icons-left is-expanded">
            <xero-input name="code" v-model="code" class="input" required placeholder="Gift Card Code" :uppercase="true" />
            <span class="icon is-left"><i class="fas fa-gift"></i></span>
        </div>
        <button type="button" class="button" style="height:inherit;" @click=" () => {$modal.show('qr-code-reader')} " aria-label="QR Code Reader Option">
            <span class="icon"><img :src=" $store.state.assetRoute + '/images/QR-Code-Reader-Icon.png' " alt="QR Code Reader Icon"></span>
            &nbsp; SCAN
        </button>

        <modal
            name="qr-code-reader"
            :adaptive="true"
            :width="'90%'"
            :height="'auto'">
            <div class="is-padded-1">
                <button type="button" class="delete" aria-label="close qr code reader window" @click=" () => {$modal.hide('qr-code-reader')} "></button>
                <h4 class="title is-4">Scan Gift Card QR Code</h4>
            </div>

            <qrcode-stream @decode=" onQRDecode "></qrcode-stream>
        </modal>
    </div>

</template>

<script>
import {QrcodeStream} from 'vue-qrcode-reader'

export default {
    name: 'Qr-Code-Redeeming',
    data() {
        return {
            code: ''
        };
    },
    methods: {
        onQRDecode: function (code) {
            if (code) {
                this.code = code;
                this.$modal.hide('qr-code-reader');
            }
        },
    },
    components: {
        QrcodeStream,
    }
}
</script>
